'use client';

import { Dialog, Spacer, Stack, Text } from '@backyard-ui/core';

import { type Review as ReviewType } from '@/infra/services/catalog/review/model';
import { algolia } from '@/infra/tracking/algolia';

import * as Review from '../../../Review';

import styles from './DetailsModal.styles';

interface DetailsModalProps {
  review: ReviewType;
}

function DetailsModal(props: DetailsModalProps) {
  const {
    review: {
      date,
      text,
      author,
      rating,
      title,
      photos,
      videos,
      badFeedbackAmount,
      goodFeedbackAmount,
      id: reviewId,
    },
  } = props;

  return (
    <Dialog.Root size="2xl" isCentered closeOnOverlayClick hasScroll>
      <Dialog.Trigger onClick={() => algolia.sendPdpClickEvent()}>
        <Text size="xl" color="green-700" weight="bold">
          Exibir avaliação completa
        </Text>
      </Dialog.Trigger>

      <Dialog.Content>
        <Dialog.CloseButton />
        <Dialog.Title>
          <Spacer size="4" />
          <Stack direction="column" spacing={{ initial: 4, md: 9 }}>
            <Review.Head author={author} date={date} rating={rating} />
            <Review.Title>{title}</Review.Title>
          </Stack>
        </Dialog.Title>

        <Dialog.Description>
          <div className={styles().description()}>
            <Stack direction="column" spacing="6">
              <Review.Description>{text}</Review.Description>
              <Review.Medias
                videos={videos}
                photos={photos}
                title="Super recomendo"
                size="sm"
              />
            </Stack>
          </div>
        </Dialog.Description>

        <Dialog.Footer>
          <div className={styles().footer()}>
            <Stack direction="column" spacing={{ initial: 4, md: 6 }}>
              <Review.Recommendation isRecommended />
              <Review.Actions
                badFeedbackAmount={badFeedbackAmount}
                goodFeedbackAmount={goodFeedbackAmount}
                reviewId={reviewId}
              />
            </Stack>
          </div>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default DetailsModal;
